export const API_URL = 'https://flashcards-scesar1.onrender.com';
